import { createContext, useContext } from 'react';
import type { Practice } from './PracticeContext';

interface PracticeContextValue {
  practice: Practice | null;
  setPractice: (practice: Practice | null) => void;
}

export const PracticeContext = createContext<PracticeContextValue>({
  practice: null,
  setPractice: () => {},
});

export function usePracticeContext() {
  return useContext(PracticeContext);
}
